/**
 * #120646 — TÊN MỤC dễ hiểu cho màn Cấu Hình Hệ Thống (app Quản lý).
 *
 * Sinh tự động từ bản vẽ sếp đã duyệt ở #115005 (`ten_muc.py`) bằng
 * `phong-ban/dev-coffee/nhan-su/120646-thicong-cauhinh-tinhnangmoi/sinh-ten-muc-js.py`.
 * Sửa tên thì sửa ở bản vẽ rồi chạy lại bộ sinh, đừng gõ tay vào đây.
 *
 * Đây CHỈ là chữ hiện cho người đọc — tên khoá kỹ thuật trong cơ sở dữ liệu giữ nguyên,
 * không đổi, không migration.
 */

// Tên tiếng Việt của từng khoá cấu hình. Khoá nào chưa có tên thì màn hình hiện thẳng tên khoá.
export const TEN_MUC_CAU_HINH = {
  BONUS_TASK_TYPES: 'Danh mục việc có thưởng nhân viên tự nhận',
  CASH_VOUCHER_AUTO_APPROVE_MINUTES: 'Bao lâu thì phiếu chi tiền mặt tự duyệt',
  CONTACT_ADMIN_PHONES: 'Số điện thoại quản lý để nhân viên gọi gấp',
  DASHBOARD_FIXED_COSTS: 'Chi phí cố định hàng tháng của quán',
  DRINK_CATEGORY_SLUGS: 'Những nhóm món tính là đồ uống',
  DRINK_WAIT_MINUTES_PER_CUP: 'Thời gian pha trung bình một ly',
  DRINK_WAIT_WARNING_THRESHOLD_MINUTES: 'Khách chờ bao lâu thì báo động',
  GAME_CHECK_QC_PHOTO_CRITERIA: 'Tiêu chí chấm ảnh kiểm bộ game',
  GAME_CHECK_SETS_PER_TASK: 'Số vị trí phải kiểm trong một việc',
  GAME_CHECK_TELEGRAM_CHAT_ID: 'Nhóm nhận kết quả kiểm bộ game',
  INVENTORY_DEDUCTION_ENABLED: 'Tự trừ kho khi bán món',
  INVENTORY_TELEGRAM_CHAT_ID: 'Nhóm nhận cảnh báo kho',
  MENU_ITEM_APPROVAL_TELEGRAM_CHAT_ID: 'Nhóm duyệt món trong thực đơn',
  MIN_SHIFTS_PER_WEEK: 'Số ca ưu tiên tối thiểu phải đăng ký',
  ORDER_APPROVAL_AUTO_APPROVE_MINUTES: 'Bao lâu thì đơn chờ được duyệt tự động',
  ORDER_MAX_DISCOUNT_AMOUNT: 'Giảm giá tối đa theo số tiền',
  ORDER_MAX_DISCOUNT_PERCENTAGE: 'Giảm giá tối đa theo phần trăm',
  PAYMENT_QR_ACCOUNT_CONFIG: 'Chọn tài khoản nhận tiền khi quét mã QR',
  PAYMENT_QR_ADD_INFO: 'Chữ hợp lệ trong nội dung chuyển khoản',
  PAYMENT_QR_REVENUE_ACCOUNT_CONFIG: 'Đổi tài khoản nhận tiền theo doanh thu tuần/tháng',
  PAYMENT_QR_SECOND_ACCOUNT_MIN_AMOUNT: 'Mức tiền tối thiểu dùng tài khoản thứ hai',
  PAYMENT_QR_SECOND_ACCOUNT_TIME_RANGE: 'Khung giờ dùng tài khoản thứ hai',
  REVENUE_ANOMALY_DAILY_THRESHOLD_PERCENT: 'Ngưỡng sụt doanh thu theo ngày',
  REVENUE_ANOMALY_ENABLED: 'Bật phát hiện doanh thu bất thường',
  REVENUE_ANOMALY_MIN_BASELINE_VND: 'Doanh thu tối thiểu mới xét bất thường',
  REVENUE_ANOMALY_THRESHOLD_PERCENT: 'Ngưỡng sụt doanh thu theo giờ',
  RND_TELEGRAM_CHAT_ID: 'Nhóm nhận tin phần thưởng ngẫu nhiên',
  RND_THRESHOLDS: 'Mốc mở phần thưởng ngẫu nhiên',
  SHIFT_AVAILABILITY_LOW_THRESHOLD: 'Mốc ca thiếu người (báo đỏ)',
  SHIFT_AVAILABILITY_MEDIUM_THRESHOLD: 'Mốc ca hơi thiếu người (báo vàng)',
  SHIFT_MATERIAL_CHECK_APPLY_ADJUSTMENT: 'Có ghi điều chỉnh kho theo số đếm thật không',
  SHIFT_MATERIAL_CHECK_ENABLED: 'Bật kiểm nguyên vật liệu theo ca',
  SHIFT_MATERIAL_CHECK_MIN_ABS_VARIANCE: 'Sàn lệch tối thiểu trước khi tính phần trăm',
  SHIFT_MATERIAL_CHECK_REQUIRE_NOTE: 'Có bắt nhập lý do khi lệch không',
  SHIFT_MATERIAL_CHECK_VARIANCE_THRESHOLD_PERCENT: 'Ngưỡng phần trăm lệch để cảnh báo',
  SHIFT_PREFERENCE_MIN_PERCENTAGE: 'Tỉ lệ đăng ký ca ưu tiên tối thiểu',
  SLIDER_POST_CONFIG: 'Cấu hình bài đăng trình chiếu',
  STOCKTAKE_VARIANCE_THRESHOLD_PERCENT: 'Ngưỡng lệch khi kiểm kho',
  TABLE_CLEANUP_CONFIG: 'Hạn dọn bàn và mức phạt nếu trễ',
  TABLE_PREP_CRITERIA: 'Tiêu chí dọn bàn trước khi khách đến',
  TELEGRAM_ANOMALY_ALERT_CHAT_ID: 'Nhóm nhận cảnh báo doanh thu bất thường',
  TELEGRAM_APPEAL_CHAT_ID: 'Nhóm nhận khiếu nại của nhân viên',
  TELEGRAM_APPROVAL_CHAT_ID: 'Nhóm duyệt chung',
  TELEGRAM_APPROVAL_CHAT_OVERTIME_ID: 'Nhóm duyệt làm thêm giờ',
  TELEGRAM_ATTENDANCE_CHAT_ID_Q10: 'Nhóm vào ca / tan ca — Quận 10',
  TELEGRAM_ATTENDANCE_CHAT_ID_QBT: 'Nhóm vào ca / tan ca — Bình Thạnh',
  TELEGRAM_ATTENDANCE_CHAT_ID_QTD: 'Nhóm vào ca / tan ca — Thủ Đức',
  TELEGRAM_CUSTOMER_FEEDBACK_CHAT_ID: 'Nhóm nhận góp ý của khách',
  TELEGRAM_ISSUE_REPORT_CHAT_ID: 'Nhóm nhận báo cáo sự cố',
  TELEGRAM_ORDER_DISCOUNT_CHAT_ID: 'Nhóm nhận tin đơn được giảm giá',
  TELEGRAM_OWNER_CHAT_ID: 'Kênh riêng của chủ quán',
  TELEGRAM_REPORT_CHAT_ID: 'Nhóm nhận báo cáo cuối ca / cuối ngày',
  TELEGRAM_REVENUE_REPORT_CHAT_ID: 'Nhóm nhận báo cáo doanh thu',
  TELEGRAM_REWARD_CHAT_ID: 'Nhóm nhận tin thưởng',
  TELEGRAM_SHIFT_PREFERENCE_ADMIN_CHAT_ID: 'Nhóm duyệt sửa / xoá ca ưu tiên',
  TELEGRAM_TABLE_SESSION_CHAT_ID: 'Nhóm nhận tin hết hạn giữ bàn',
  TELEGRAM_TASK_CHAT_ID: 'Nhóm nhận tin công việc trong ca',
  UPLOAD_SERVICE: 'Nơi lưu ảnh tải lên',
  VAT_RATE: 'Thuế giá trị gia tăng',
  appeal_auto_approve_rules: 'Khiếu nại nào được duyệt tự động',
  appeal_deadline_hours: 'Hạn gửi khiếu nại',
  appeal_escalation: 'Nhắc và đẩy lên cấp trên khi khiếu nại bị bỏ quên',
  cashier_revenue_multiplier: 'Hệ số doanh thu cho vị trí thu ngân',
  default_hourly_rate: 'Lương giờ mặc định của nhân viên mới',
  flagged_banner_content: 'Băng cảnh báo hiện cho nhân viên bị gắn cờ',
  high_performer_threshold: 'Ngưỡng điểm cao cần chú ý',
  holiday_bonus_points: 'Điểm thưởng ca lễ',
  holiday_salary_multiplier: 'Hệ số lương ngày lễ',
  hourly_rate_increase: 'Mỗi lần nâng lương tăng thêm bao nhiêu',
  hourly_rate_max: 'Trần lương theo giờ',
  hourly_rate_threshold_hours: 'Ngưỡng giờ xét tăng lương (KHÔNG CÒN DÙNG)',
  issue_report_default_bonus: 'Mức thưởng mặc định khi duyệt báo cáo sự cố',
  late_checkin_penalty_enabled: 'Có trừ điểm khi đi trễ không',
  late_checkin_penalty_tiers: 'Bậc trừ điểm theo mức độ đi trễ',
  late_penalty_per_minute: 'Số điểm trừ mỗi phút đi trễ',
  low_performer_threshold: 'Ngưỡng điểm thấp cần chú ý',
  night_bonus_points: 'Điểm thưởng ca đêm',
  non_cashier_revenue_multiplier: 'Hệ số doanh thu cho vị trí không thu ngân',
  normal_bonus_points: 'Điểm thưởng ca thường',
  order_phone_view_auto_approve_seconds: 'Bao lâu thì yêu cầu xem số khách tự duyệt',
  overtime_rate: 'Hệ số lương làm thêm giờ',
  overtime_salary_multiplier: 'Hệ số lương ca đêm 22h–2h',
  peak_hour_bonus_points: 'Điểm thưởng ca giờ cao điểm',
  point_accumulate_percentage: 'Phần trăm đơn quy thành điểm cho khách',
  point_to_hour_rate: 'Quy đổi điểm ra giờ làm',
  point_value: 'Một điểm đáng bao nhiêu tiền',
  qc_config: 'Số phiên và số ảnh phải chấm QC',
  'random_reward.gemini_api_key': 'Chìa khoá dịch vụ AI Gemini',
  'random_reward.groq_api_key': 'Chìa khoá dịch vụ AI Groq',
  revenue_reward_thresholds: 'Mốc doanh thu và tỉ lệ thưởng',
  salary_advance_max_percent: 'Trần ứng lương mỗi kỳ',
  shift_absence_penalty_enabled: 'Có trừ điểm khi bỏ ca không',
  shift_absence_penalty_multiplier: 'Mức nặng nhẹ của phạt bỏ ca',
  shift_leaderboard_points_per_shift: 'Điểm mỗi suất ca trong bảng xếp hạng đăng ký',
  shift_leaderboard_reward_tiers: 'Thưởng thêm cho top 1/2/3 bảng xếp hạng',
  shift_preference_penalty_enabled: 'Có trừ điểm khi bỏ ca ưu tiên đã đăng ký không',
  shift_registration_enabled: 'Cho nhân viên đăng ký ca hay không',
  'slider_post.api_key': 'Chìa khoá kết nối hệ thống đăng bài',
  staff_app_base_url: 'Địa chỉ web app Ồn Staff',
  weekend_bonus_points: 'Điểm thưởng ca cuối tuần',
  wrong_checkout_location_penalty: 'Phạt khi tan ca sai vị trí quán',
};

// Tên tiếng Việt của từng nhóm cấu hình (cột `category` trong cơ sở dữ liệu).
export const TEN_NHOM_CAU_HINH = {
  ATTENDANCE: 'Vào ca / tan ca',
  BONUS_TASK: 'Việc có thưởng',
  EMPLOYEE: 'Nhân viên',
  FEATURE_FLAG: 'Công tắc tính năng mới',
  ORDER: 'Đơn hàng',
  PAYROLL: 'Lương',
  PERFORMANCE: 'Vận hành & hiệu suất',
  POINT: 'Điểm thưởng & phạt',
  SHIFT: 'Ca làm việc',
  SHIFT_LEADERBOARD: 'Bảng xếp hạng ca',
  dashboard: 'Bảng điều khiển',
  game: 'Bộ game',
  reservation: 'Đặt bàn',
  slider_post: 'Bài đăng trình chiếu',
};

export function tenMuc(khoa) {
  return TEN_MUC_CAU_HINH[khoa] || khoa;
}

export function tenNhom(nhom) {
  return TEN_NHOM_CAU_HINH[nhom] || nhom;
}
